module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av282-da406e8f426a4b3d1f5cc7ff756ac936.jpg";